import Funding from "../components/Funding";

export default function FundingPage() {
  return (
    <section className="py-10">
      <Funding />
    </section>
  );
}
